<script>
  import {Line} from 'vue-chartjs'
  import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
  import {getStyle} from '@coreui/coreui-pro/dist/js/coreui-utilities'
  import _ from 'lodash';

  export default {
    extends: Line,
    props: ['height', 'width', 'data'],
    computed: {
      arrivalsDayLabels() {
        return _.map(this.data, 'day')
      },
      arrivalsDayData() {
        return _.map(this.data, 'sum_net_kilograms')
      },
    },
    mounted() {
      const brandPrimary = getStyle('--primary') || '#20a8d8'
      const datasets1 = [
        {
          label: 'Kg Netos',
          backgroundColor: 'transparent',
          borderColor: brandPrimary,
          data: this.arrivalsDayData,
        }
      ];

      this.renderChart(
        {
          labels: this.arrivalsDayLabels,
          datasets: datasets1
        },
        {
          tooltips: {
            enabled: false,
            custom: CustomTooltips
          },
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [
              {
                gridLines: {
                  color: 'transparent',
                  zeroLineColor: 'transparent'
                },
                ticks: {
                  fontSize: 2,
                  fontColor: 'transparent'
                }
              }
            ],
            yAxes: [
              {
                display: false,
                ticks: {
                  display: false,
                  min: Math.min.apply(Math, datasets1[0].data) - 5,
                  max: Math.max.apply(Math, datasets1[0].data) + 5
                }
              }
            ]
          },
          elements: {
            line: {
              borderWidth: 2
            },
            point: {
              radius: 4,
              hitRadius: 10,
              hoverRadius: 4
            }
          }
        }
      )
    }
  }
</script>
